import type { InferSubmit } from '@if/core/yup'
import * as yup from '@if/core/yup'

// The three ways a selection of pending lender payments is disbursed. Each is the `origin` of
// its submit button, so one onSubmit branches on it.
export const EDisbursementAction = {
  AptPay: 'aptPay',
  ApplyCheque: 'applyCheque',
  GenerateAcpFile: 'generateAcpFile',
} as const
export type EDisbursementAction = (typeof EDisbursementAction)[keyof typeof EDisbursementAction]

export const isDisbursementAction = (value: string): value is EDisbursementAction =>
  Object.values<string>(EDisbursementAction).includes(value)

// Module scope: the form needs a referentially stable schema.
export const disbursementSelectionSchema = yup.object({
  lenderPaymentOperationIds: yup.array().of(yup.number().required()).required().min(1).default([]),
})

export type DisbursementSelectionSchemaType = InferSubmit<typeof disbursementSelectionSchema>
